import { render } from "./ConsoleGame.vue?vue&type=template&id=200a353a"
import script from "./ConsoleGame.vue?vue&type=script&lang=js"
export * from "./ConsoleGame.vue?vue&type=script&lang=js"

import "./ConsoleGame.vue?vue&type=style&index=0&id=200a353a&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__